import service from "./baseRequest.js";
//import { setToken } from "../../utils/jwt/tokenUtils.js";

export function login(loginForm) {
  return service.post("login", loginForm);
}
